// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2vmok","header":"PatientQuestionnaire_header__2YCsH","info":"PatientQuestionnaire_info__12nbN"};